var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"dis-hover":""}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._t("title"),_c('p',{staticClass:"title-item"},[_vm._v(_vm._s(this.$t('common.this_day')))])],2),_c('div',[_c('hot',{attrs:{"useScene":_vm.scene}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }